import {initialState, NAME_SLICE} from "./constants";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const operationSlice = createSlice({
    name: NAME_SLICE,
    initialState,
    reducers: {
        getStarving: (state) => {
            state.starving.loading = true;
        },
        getStarvingSuccess: (state, action: PayloadAction<string[][]>) => {
            state.starving.loading = false;
            state.starving.data = action.payload;
        },
        getStarvingFailure: (state) => {
            state.starving.loading = false;
        },
    },
})

export const operationActions = operationSlice.actions

const operationReducer = operationSlice.reducer;

export default operationReducer;
